import api from '../library/axios';

export default {
  getList() {
    return api({
      method: 'get',
      url: '/api/ws-products',
    });
  },
  getListBot() {
    return api({
      method: 'get',
      url: '/api/ws-bot-products',
    });
  },
};
